/* eslint-disable no-plusplus */
/* eslint-disable react/prop-types */
/* eslint-disable max-len */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-nested-ternary */
import React, {
  useState, useEffect, useMemo, useRef,
} from 'react';
import { createPortal } from 'react-dom';
import { batch, useDispatch, useSelector } from 'react-redux';
import styled from '@emotion/styled';
import IcomoonReact from 'icomoon-react';
import PropTypes from 'prop-types';
import Shimmer from 'react-shimmer-effect';
import { openPopupWidget } from 'react-calendly';
import { useLocation } from 'react-router-dom';
import { push } from 'connected-react-router';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import { Global, css } from '@emotion/core';
import getAllUrlParams from '../../../../shared/utils/getAllUrlParams';

import corePackage, {
  includedModules,
  getFilteredCoreModules,
  addOns,
  arePackagesEqual,
  updatePackages,
} from './packages';
import iconSet from '../../../../shared/images/teambuildr-selection.json';
import { BoxShadow } from '../../../../shared/GlobalStyles';
import {
  setIsUpgradeModalShowing,
  fetchSubscriptionPackage,
  fetchSubscriptionStatus,
  setSelectedPackage,
  setIsSideBarExpandedGlobal,
  setIsLearnMoreModalShowing,
  setIsUpdatedUpgradeModalShowing,
} from '../../ducks/sportsScienceActions';
import {
  dashboardTracker,
  subscriptionFlowTracker,
  subscriptionFlowTrackerDemo,
} from '../../../../shared/utils/amplitudeHelper';

const SideBarDiv = styled('div')`
  transition: all 0.3s ease;
  margin-top: ${(props) => (props.hideNav ? '0' : '49px')};
  box-shadow: 0px 16px 24px 0px rgba(48, 49, 51, 0.1),
    0px 0px 1px 0px rgba(48, 49, 51, 0.05),
    0px -6px 16px 0px rgba(48, 49, 51, 0.18);
  overflow-y: hidden;
  height: 100%;
  z-index: 1;
  width: ${(props) => (props.isExpanded ? '300px' : '110px')};
  @media screen and (max-width: 714px) {
    width: ${(props) => (props.isSideBarActive ? '100%' : '0%')};
  }
`;

const SideBarHeader = styled('div')`
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: 'Nunito Sans';
  font-size: ${(props) => (props.isExpanded ? '13px' : '16px')};
  font-style: normal;
  font-weight: ${(props) => (props.isExpanded ? 700 : 900)};
  line-height: 150%;
  display: flex;
  align-items: center;
  padding: ${(props) => (props.isExpanded ? '24px 16px' : '24px 20px')};
  box-shadow: ${(props) => (props.showShadow ? '0 2px 8px rgba(0,0,0,0.08)' : 'none')};
  transition: box-shadow 0.2s;
  justify-content: ${(props) => (props.isExpanded ? 'space-between' : 'center')};
  @media screen and (max-width: 714px) {
    justify-content: space-between;
    display: none;
  }
`;

const HeaderText = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 16px;
  font-weight: 700;
  margin-right: ${(props) => (props.isExpanded ? '0px' : '6px')};
`;

const MenuAndButtons = styled('div')`
  width: 100%;
  gap: 16px;
  margin-bottom: ${(props) => (props.coreUnlocked ? '135px' : props.isExpanded ? '175px' : '200px')};
  overflow: auto;
  flex: 1 auto;
  display: flex;
  flex-direction: column;
  overflow: ${(props) => (props.isExpanded ? 'hidden' : 'clip')};
  overflow-y: auto;
  scrollbar-width: thin;
  padding: 8px 0 8px 15px;
  @media screen and (max-width: 714px) {
    flex-direction: column;
    align-items: center;
    margin-top: 15px;
    padding-left: 15px;
    padding-right: 15px;
  }
`;

const MenuTab = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: ${(props) => (props.isExpanded ? '15px' : '0px')};
  gap: 16px;
  min-height: 80px;
  height: 80px;
  width: ${(props) => (props.isExpanded ? (!props.hasLocked ? '270px' : '265px') : '80px')};
  background: ${(props) => (props.isAddon
    ? props.unlocked
      ? 'white'
      : 'linear-gradient(270deg, #6A82FB 0%, #FC5C7D 100%)'
    : !props.activeTab
      ? !props.unlocked
        ? 'linear-gradient(270deg, #fc4a1a 0%, #f7b733 100%);'
        : 'white'
      : 'white')};
  border-radius: 8px;
  color: ${(props) => (!props.activeTab ? (props.unlocked ? '#9E9E9E' : 'white') : '#9E9E9E')};
  position: relative;
  box-sizing: border-box;
  border: ${(props) => (props.activeTab
    ? '1px solid #0DCC8A'
    : props.unlocked
      ? '#9E9E9E'
      : 'white')};
  box-shadow: 0px 4px 8px 0px rgba(48, 49, 51, 0.1),
    0px 0px 1px 0px rgba(48, 49, 51, 0.05);
  transition: all 0.3s ease;
  cursor: pointer;
  margin-right: ${(props) => (props.hasLockedPackage ? (props.isExpanded ? '10px' : '4px') : '')};
  @media screen and (max-width: 714px) {
    width: 100%;
  }
  svg path {
    fill: white;
    stroke: transparent;
  }
`;

const MenuTabContent = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  width: 100%;
  &:hover {
    opacity: 0.7;
  }
`;

const ShimmerMenuTab = styled('div')`
  width: ${(props) => (props.isExpanded ? '270px' : '80px')};
  min-height: 80px;
  height: 80px;
  border-radius: 8px;
  box-shadow: ${BoxShadow};
  @media screen and (max-width: 714px) {
    width: 100%;
  }
`;

const TabTitle = styled('div')`
  font-family: 'Nunito Sans';
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: ${(props) => (props.activeTab ? 'black' : props.unlocked ? 'black' : 'white')};
  transition: all 0.3s ease;
  display: ${(props) => (props.isExpanded ? 'flex' : 'none')};
  @media screen and (max-width: 714px) {
    display: flex;
  }
`;

const TitleAndDescription = styled('div')`
  display: flex;
  flex-direction: column;
`;

const IconContainer = styled('div')`
  margin-left: ${(props) => (props.isSideBarExpanded ? '0px' : '21px')};
  transition: all 0.3s ease;
`;

const ModalButtons = styled('div')`
  display: flex;
  padding: 16px 0px;
  gap: 8px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  width: 100%;
  bottom: 50px;
  padding: ${(props) => (props.isSideBarExpanded ? '15px' : '5px')};
  @media screen and (max-width: 714px) {
    padding: 15px;
  }
`;

const DemoButtonIconContainer = styled('div')`
  margin-right: ${(props) => (props.isSideBarExpanded ? '10px' : '0px')};
  @media screen and (max-width: 714px) {
    margin-right: 10px;
  }
`;

const UpgradeButtonIconContainer = styled('div')`
  margin-right: ${(props) => (props.isSideBarExpanded ? '10px' : '0px')};
  background: ${(props) => (props.isSideBarExpanded ? '#444444' : '#ffffff')};
  height: 24px;
  width: 24px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  @media screen and (max-width: 714px) {
    margin-right: 10px;
  }
`;

const SpacingWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
  background: white;
`;

const LockContainer = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${(props) => (props.isExpanded ? '45px' : '20px')};
  width: ${(props) => (props.isExpanded ? '45px' : '20px')};
  background: #444444;
  position: absolute;
  right: ${(props) => (props.isExpanded ? '-10px' : '-5px')};
  top: -10px;
  border-radius: 50%;
  cursor: pointer;
  opacity: ${(props) => (props.isActive ? 1 : 0)};
  transition: opacity 0.3s ease;
`;

const UpgradeButton = styled('div')`
  display: ${(props) => (props.isActive ? 'flex' : 'none')};
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-radius: ${(props) => (props.isExpanded ? '10000px' : '8px')};
  border: 3px solid #444444;
  height: ${(props) => (props.isExpanded ? '40px' : '60px')};
  width: ${(props) => (props.isExpanded ? '100%' : '80px')};
  margin-bottom: 5px;
  color: #444444;
  font-family: 'Nunito Sans';
  font-size: 13px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%; /* 19.5px */
  letter-spacing: 0.39px;
  line-height: 20px;
  cursor: ${(props) => (props.isActive ? 'pointer' : 'default')};
  background: #ffffff;
  opacity: ${(props) => (props.isActive ? 1 : 0)};
  transition: opacity 0.3s ease;
  padding: ${(props) => (props.isExpanded ? '8px 12px' : '12px 20px')};
  .button-text {
    display: ${(props) => (props.isExpanded ? 'flex' : 'none')};
  }
  @media screen and (max-width: 714px) {
    border-radius: 10000px;
    height: 40px;
    width: 100%;
    padding: 8px 12px;
    .button-text {
      display: flex;
    }
  }

  &:hover {
    opacity: 0.7;
  }
`;

const BookModalButton = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${(props) => (props.isExpanded ? '10000px' : '8px')};
  height: ${(props) => (props.isExpanded ? '40px' : '60px')};
  width: ${(props) => (props.isExpanded ? '100%' : '80px')};
  color: white;
  font-family: 'Nunito Sans';
  font-size: 13px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%; /* 19.5px */
  letter-spacing: 0.39px;
  cursor: pointer;
  background: #444444;
  border: 3px solid transparent;
  color: #ffffff;
  transition: all 0.3s ease;
  padding: ${(props) => (props.isExpanded ? '8px 12px' : '12px 20px')};
  .button-text {
    display: ${(props) => (props.isExpanded ? 'flex' : 'none')};
  }
  @media screen and (max-width: 714px) {
    border-radius: 10000px;
    height: 40px;
    width: 100%;
    padding: 8px 12px;
    .button-text {
      display: flex;
    }
  }

  &:hover {
    opacity: 0.7;
  }
`;

const ChevronContainer = styled('div')`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

const Chevron = styled('div')`
  transform: ${(props) => (props.isRotated ? 'rotate(180deg)' : 'rotate(0deg)')};
  transition: transform 0.3s ease;
  width: auto;
  height: auto;
  display: flex;
  justify-content: center;
`;

const Badge = styled.button`
  background: ${(props) => (props.isCore
    ? 'linear-gradient(white, white) padding-box, linear-gradient(to right, #FC4A1A 50%, #F7B733 100%) border-box'
    : 'linear-gradient(white, white) padding-box, linear-gradient(to left, #6A82FB 50%, #FC5C7D 100%) border-box')};

  border-radius: 50em;
  border: 1px solid transparent;
  position: absolute;
  left: 12px;
  top: -8px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  font-size: 1em;
  color: #444;
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: 'Nunito Sans';
  font-size: 11px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%; /* 16.5px */
  padding: 2px 12px 0px 12px;
  display: ${(props) => (props.isExpanded ? 'block' : 'none')};
`;

// Styling modeled from TBTooltip
const TooltipContainer = styled('div')`
  position: fixed;
  z-index: 1000;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  text-align: center;
  background: #444444;
  color: #ffffff;
  padding: 8px;
  border-radius: 6px;
  box-shadow: 0px 0px 1px rgb(48 49 51 / 5%), 0px 4px 8px rgb(48 49 51 / 10%);
  white-space: pre-line;
  font-family: 'Nunito Sans';
  word-wrap: break-word;
  font-size: 13px;
  line-height: 20px;
  font-weight: 700;
  max-width: 250px;
  width: ${(props) => (props.isSideBarExpanded ? '250px' : '200px')};
  pointer-events: none;
  transform: translate(-50%, -100%);
  @media screen and (max-width: 714px) {
    width: calc(100% - 32px); // subtracting padding to prevent overflow
    max-width: none;
  }

  &:after {
    content: '';
    position: absolute;
    bottom: -5px;
    left: ${(props) => (props.isSideBarExpanded
    ? '50%'
    : '20%')}; // shift arrow to left when sidebar collapsed
    transform: translateX(-50%);
    border-width: 5px 5px 0;
    border-style: solid;
    border-color: #444444 transparent transparent;
    @media screen and (max-width: 714px) {
      left: 50%;
    }
  }
`;

// Portal required for tooltip to render properly outside of SideBar
// coordinates used to position tooltip relative to associated menu tab
const MenuTabTooltip = ({
  text, x, y, isSideBarExpanded, isSideBarActive,
}) => {
  if (!text || !x || !y) return null;

  return createPortal(
    <TooltipContainer
      style={{
        left: x,
        top: y,
      }}
      isSideBarExpanded={isSideBarExpanded}
      isSideBarActive={isSideBarActive}
    >
      {text}
    </TooltipContainer>,
    document.body,
  );
};

const SideBar = ({
  isSideBarActive,
  setIsSideBarActive,
  flags,
  containerWidth,
}) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const currentUser = useSelector((state) => state.auth.data.currentUser);
  const subscriptionStatus = useSelector(
    (state) => state.sportsScience.data.subscriptionStatus,
  );
  const isPackageLoading = useSelector(
    (state) => state.sportsScience.ui.isPackageLoading,
  );
  const addedPackage = useSelector(
    (state) => state.sportsScience.data.addedPackage,
  );
  const isSideBarExpanded = useSelector(
    (state) => state.sportsScience.data.isSideBarExpanded,
  );
  const [activeTab, setActiveTab] = useState('');
  const [menuTabScroll, setMenuTabScroll] = useState(false);
  const [tooltipData, setTooltipData] = useState({
    text: '',
    x: null,
    y: null,
  });
  const menuRef = useRef(null);

  // Determine Platinum Pro plan and entitlement flags for VBT visibility
  const organizationAccessLevel = currentUser?.organizationAccessLevel;
  const isPlatinumPro = organizationAccessLevel === 7;
  const vbtDashStandAloneEnabled = currentUser?.userOrgSSHubSettings?.vbtDashStandAloneEnabled;
  const shouldShowVbtOption = isPlatinumPro;

  const isCorePackageSubscribed = subscriptionStatus?.packageSubscriptionStatus?.isSubscribed;

  // Used to show/hide shadow on top box of side bar depending on scroll activity
  useEffect(() => {
    const menu = menuRef.current;
    if (!menu) return;

    const handleScroll = () => {
      setMenuTabScroll(menu.scrollTop > 0);
    };

    menu.addEventListener('scroll', handleScroll);

    // Clean up on unmount
    return () => {
      menu.removeEventListener('scroll', handleScroll);
    };
  }, [menuRef]);

  /**
   * Temporarily showing modules' legacy title in the tooltip;
   * eventually textToHover can just be packageItem.description in TBTooltip props
   */
  const hoverText = (packageItem) => {
    const expandedText = packageItem.legacyTitle
      ? `${packageItem.description}\n(Formerly ${packageItem.legacyTitle})`
      : packageItem.description;

    if (containerWidth < 715 || isSideBarExpanded) {
      return expandedText;
    }
    return packageItem.title;
  };

  // Show tooltip when mouse enters menu tab
  const handleMenuTabMouseEnter = (packageItem) => (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    setTooltipData({
      text: hoverText(packageItem),
      x:
        isSideBarExpanded || containerWidth < 715
          ? rect.right - rect.width / 2
          : rect.right + 20,
      y: rect.top + (rect.height / 4 - 10),
    });
  };

  // Remove tooltip when mouse leaves menu tab
  const handleMenuTabMouseLeave = () => {
    setTooltipData({
      text: '',
      x: null,
      y: null,
    });
  };

  // getFilteredCoreModules is used to filter the core modules based on which flags are enabled
  // Used to map out MenuTab elements
  const getPackages = useMemo(() => {
    const coreModules = getFilteredCoreModules(flags).map((module) => ({
      ...module,
      unlocked: false,
    }));
    // Only show VBT add-on to Platinum Pro orgs
    const visibleAddOns = addOns
      .filter((module) => module.addOnId !== 2 || shouldShowVbtOption)
      .map((module) => ({
        ...module,
        unlocked: false,
      }));
    return [
      ...includedModules,
      ...coreModules,
      ...visibleAddOns,
    ];
  }, [flags, shouldShowVbtOption]);

  const [packages, setPackages] = useState(getPackages);

  // Check for hideNav query parameter
  const urlParams = getAllUrlParams(window.location.href, false);
  const hideNav = urlParams.hideNav === 'true';
  const hasLockedPackage = packages.some(
    (packageItem) => !packageItem.unlocked,
  );

  useEffect(() => {
    setPackages(getPackages);
  }, [flags, shouldShowVbtOption]);

  useEffect(() => {
    const { pathname } = location;
    // Avoid any unnecessary checks/redirects if the subscription status has not been fetched yet.
    if (!subscriptionStatus) {
      return;
    }

    // If attempting to access VBT path and shouldShowVbtOption is false, silently redirect to AMS home
    if (pathname === '/ams/vbt-dashboard' && !shouldShowVbtOption) {
      dispatch(push('/ams'));
      return;
    }

    // Defines a mapping of routes to their required subscription types.
    const allowedPackagePaths = {
      '/ams/wearables-dashboard': { requiredSubscription: 'none' },
      '/ams/load-monitoring-dashboard': {
        requiredSubscription: 'core',
      },
      '/ams/kpi-tracker': { requiredSubscription: 'core' },
      '/ams/force-plate-dashboard': { requiredSubscription: 1 }, // the addon id
      '/ams/volume-tracker': { requiredSubscription: 'core' },
      // Only enforce VBT subscription checks if the option is visible
      ...(shouldShowVbtOption ? { '/ams/vbt-dashboard': { requiredSubscription: 2 } } : {}),
    };

    if (flags.habitTracking) {
      allowedPackagePaths['/ams/habit-tracker'] = {
        requiredSubscription: 'core',
      };
    }

    if (flags.bodyHeatMaps) {
      allowedPackagePaths['/ams/body-heatmap'] = {
        requiredSubscription: 'core',
      };
    }

    // Retrieves the required subscription type for the current pathname.
    const requiredSubscription = allowedPackagePaths[pathname]?.requiredSubscription;
    let hasRequiredSubscription = false;

    // For wearables dashboard, no subscription is required.
    if (requiredSubscription === 'none') {
      hasRequiredSubscription = true;
    } else if (requiredSubscription === 'core') {
      // For core packages, checks if the user is subscribed to the core package.
      hasRequiredSubscription = subscriptionStatus?.packageSubscriptionStatus?.isSubscribed === true;
    } else if (typeof requiredSubscription === 'number') {
      // For add-on packages, checks if the user is subscribed to the required add-on package.
      hasRequiredSubscription = subscriptionStatus?.addOnsSubscriptionStatus.some(
        (addon) => addon.addOnId === requiredSubscription && addon.isSubscribed,
      ) || (requiredSubscription === 2 && vbtDashStandAloneEnabled === true);
    }

    if (hasRequiredSubscription || pathname === '/ams') {
      setActiveTab(pathname);
    } else {
      const dashName = pathname.split('/')[2];
      dispatch(push(`/ams?previous=${dashName}`));
    }
  }, [subscriptionStatus, currentUser, shouldShowVbtOption]);

  useEffect(() => {
    if (Object.keys(currentUser).length) {
      dispatch(fetchSubscriptionStatus(currentUser.accountCode, 1));
    }
  }, [currentUser, addedPackage]);

  const updatedPackages = useMemo(
    () => updatePackages(packages, subscriptionStatus, isCorePackageSubscribed),
    [subscriptionStatus, packages, isCorePackageSubscribed],
  );

  // Reflect standalone VBT as unlocked for UI when enabled
  const updatedPackagesWithVbtOverride = useMemo(
    () => (vbtDashStandAloneEnabled
      ? updatedPackages.map((p) => (p.addOnId === 2 ? { ...p, unlocked: true } : p))
      : updatedPackages),
    [updatedPackages, vbtDashStandAloneEnabled],
  );

  useEffect(() => {
    // Assuming arePackagesEqual is a deep comparison function
    if (!arePackagesEqual(updatedPackagesWithVbtOverride, packages)) {
      setPackages(updatedPackagesWithVbtOverride);
    }
  }, [updatedPackagesWithVbtOverride]);

  // Set info for amplitude functions below based on active tab
  const getAmplitudeInfoFromActiveTab = () => {
    let title;
    let core;
    let addOn;
    switch (activeTab) {
      case '/ams/wearables-dashboard':
        addOn = false;
        core = false;
        title = 'Wearables Dashboard';
        break;
      case '/ams/load-monitoring-dashboard':
        addOn = false;
        core = true;
        title = 'Load Monitoring Dashboard';
        break;
      case '/ams/kpi-tracker':
        addOn = false;
        core = true;
        title = 'Sport Coach Dashboard';
        break;
      case '/ams/habit-tracker':
        addOn = false;
        core = true;
        title = 'Consistency Coach';
        break;
      case '/ams/force-plate-dashboard':
        addOn = true;
        core = false;
        title = 'Force Plate Dashboard';
        break;
      case '/ams/body-heatmap':
        addOn = false;
        core = true;
        title = 'Recovery Radar';
        break;
      case '/ams/volume-tracker':
        addOn = false;
        core = true;
        title = 'Volume Tracker';
        break;
      case '/ams/vbt-dashboard':
        addOn = true;
        core = false;
        title = 'VBT Dashboard';
        break;
      default:
        addOn = false;
        core = false;
        title = 'AMS Homepage';
    }
    return { title, core, addOn };
  };

  // Tracks which module was active when user clicked upgrade4
  const handleAmplitudeUpgrade = () => {
    const { title } = getAmplitudeInfoFromActiveTab();
    subscriptionFlowTracker('Upgrade Sidebar Started', 'none', title);
  };

  // Tracks which module was active when user booked a demo
  const handleAmplitudeDemo = () => {
    const packageData = getAmplitudeInfoFromActiveTab();
    subscriptionFlowTrackerDemo('Sidebar', packageData);
  };

  // Tracks which module/dashboard was opened
  const handleAmplitudeModule = (title) => {
    dashboardTracker(title, null, null);
  };

  // Tracks which module's modal was opened
  const handleAmplitudeModal = (title) => {
    subscriptionFlowTracker('Modal Viewed', title, 'none');
  };

  const handleMenuTabClick = (packageItem) => {
    // If module locked, open upgrade modal specific to module
    if (!packageItem.unlocked) {
      handleAmplitudeModal(packageItem.legacyTitle || packageItem.title);
      batch(() => {
        dispatch(setSelectedPackage(packageItem));
        dispatch(
          fetchSubscriptionPackage(
            currentUser.accountCode,
            1,
            !packageItem.core ? packageItem.addOnId : null,
          ),
        );
        if (
          packageItem.id === 4
          || packageItem.id === 5
          || packageItem.id === 7
          || packageItem.id === 8
        ) {
          dispatch(setIsUpdatedUpgradeModalShowing(true));
        } else {
          dispatch(setIsUpgradeModalShowing(true));
        }
      });
    } else {
      // If module unlocked, navigate to it
      handleAmplitudeModule(packageItem.legacyTitle || packageItem.title);
      dispatch(push(packageItem.activeTab));
      setIsSideBarActive(false);
    }
  };

  return (
    <SideBarDiv
      isSideBarActive={isSideBarActive}
      isExpanded={isSideBarExpanded}
      hideNav={hideNav}
    >
      <Global
        styles={css`
          .calendly-overlay {
            background-color: rgba(31, 31, 31, 0.8) !important;
          }
          .calendly-overlay .calendly-popup-close {
            top: 55px !important;
            right: 55px !important;
            width: 25px !important;
            height: 25px !important;
            @media screen and (max-width: 649px) {
              top: 12px !important;
              right: 12px !important;
              width: 25px !important;
              height: 25px !important;
            }
          }
        `}
      />
      <SpacingWrapper>
        <SideBarHeader
          isExpanded={isSideBarExpanded}
          isSideBarActive={isSideBarActive}
          showShadow={menuTabScroll}
        >
          {isSideBarExpanded && (
            <HeaderText isExpanded={isSideBarExpanded}>
              {isSideBarExpanded ? 'ALL MODULES' : 'MODS'}
            </HeaderText>
          )}
          <ChevronContainer
            onClick={() => {
              dispatch(setIsSideBarExpandedGlobal(!isSideBarExpanded));
            }}
          >
            <Chevron isRotated={isSideBarExpanded}>
              <IcomoonReact
                iconSet={iconSet}
                size={18}
                icon='altrightarrow'
                color='black'
              />
            </Chevron>
          </ChevronContainer>
        </SideBarHeader>
        <MenuAndButtons
          ref={menuRef}
          isExpanded={isSideBarExpanded}
          hasLocked={packages.some((item) => item.unlocked === false)}
          coreUnlocked={isCorePackageSubscribed}
        >
          {subscriptionStatus && !isPackageLoading ? (
            <MenuTab
              isExpanded={isSideBarExpanded}
              activeTab={activeTab === '/ams'}
              unlocked
              hasLockedPackage={hasLockedPackage}
              onClick={() => {
                handleAmplitudeModule('AMS Homepage');
                dispatch(push('/ams'));
                setIsSideBarActive(false);
              }}
            >
              <MenuTabContent>
                <IconContainer
                  activeTab={activeTab === '/ams'}
                  isSideBarExpanded={isSideBarExpanded}
                >
                  <IcomoonReact
                    iconSet={iconSet}
                    size={40}
                    icon='home'
                    color='#444444'
                  />
                </IconContainer>
                <TitleAndDescription>
                  <TabTitle
                    isExpanded={isSideBarExpanded}
                    unlocked
                    activeTab={activeTab === '/ams'}
                  >
                    View All Modules
                  </TabTitle>
                </TitleAndDescription>
              </MenuTabContent>
            </MenuTab>
          ) : (
            <Shimmer>
              <ShimmerMenuTab isExpanded={isSideBarExpanded} />
            </Shimmer>
          )}
          {packages.map((packageItem) => (subscriptionStatus && !isPackageLoading ? (
            <MenuTab
              key={packageItem.id}
              isExpanded={isSideBarExpanded}
              activeTab={activeTab === packageItem.activeTab}
              unlocked={packageItem.unlocked}
              hasLockedPackage={hasLockedPackage}
              isAddon={packageItem.core === false && !!packageItem.addOnId}
              onMouseEnter={handleMenuTabMouseEnter(packageItem)}
              onMouseLeave={handleMenuTabMouseLeave}
              onClick={() => handleMenuTabClick(packageItem)}
            >
              <MenuTabContent>
                <IconContainer
                  activeTab={activeTab === packageItem.activeTab}
                  isSideBarExpanded={isSideBarExpanded}
                >
                  <IcomoonReact
                    iconSet={iconSet}
                    size={40}
                    icon={packageItem.icon}
                    color={
                        activeTab === packageItem.activeTab
                        || packageItem.unlocked
                          ? '#444444'
                          : 'white'
                      }
                  />
                </IconContainer>
                <TitleAndDescription>
                  <TabTitle
                    isExpanded={isSideBarExpanded}
                    unlocked={packageItem.unlocked}
                    activeTab={activeTab === packageItem.activeTab}
                  >
                    {packageItem.title}
                  </TabTitle>
                </TitleAndDescription>
              </MenuTabContent>
              <LockContainer
                isActive={!packageItem.unlocked}
                isExpanded={isSideBarExpanded}
              >
                <IcomoonReact
                  iconSet={iconSet}
                  size={isSideBarExpanded ? 25 : 12}
                  icon={packageItem.core ? 'lock' : 'star'}
                  color='white'
                />
              </LockContainer>
              {!packageItem?.unlocked
                  && (packageItem.core ? (
                    <Badge isCore isExpanded={isSideBarExpanded}>
                      CORE SUBSCRIPTION
                    </Badge>
                  ) : (
                    <Badge isExpanded={isSideBarExpanded}>ADD ON</Badge>
                  ))}
            </MenuTab>
          ) : (
            <Shimmer key={packageItem.id}>
              <ShimmerMenuTab isExpanded={isSideBarExpanded} />
            </Shimmer>
          )))}
        </MenuAndButtons>
        <ModalButtons isSideBarExpanded={isSideBarExpanded}>
          {!isCorePackageSubscribed && (
            <BookModalButton
              isExpanded={isSideBarExpanded}
              onClick={() => {
                handleAmplitudeDemo();
                openPopupWidget({
                  url:
                    'https://calendly.com/teambuildr/15-minute-sports-science-hub',
                });
              }}
              onMouseEnter={
                !isSideBarExpanded
                  ? handleMenuTabMouseEnter({
                    title: 'Book a demo',
                    legacyTitle: '',
                    description: '',
                  })
                  : null
              }
              onMouseLeave={!isSideBarExpanded ? handleMenuTabMouseLeave : null}
            >
              <DemoButtonIconContainer isSideBarExpanded={isSideBarExpanded}>
                <IcomoonReact
                  iconSet={iconSet}
                  size={isSideBarExpanded ? 16 : 24}
                  icon='calendar'
                  color='#ffffff'
                />
              </DemoButtonIconContainer>
              <div className='button-text'>BOOK A DEMO</div>
            </BookModalButton>
          )}
          {isCorePackageSubscribed ? (
            <UpgradeButton
              isExpanded={isSideBarExpanded}
              isActive={isCorePackageSubscribed}
              onClick={() => {
                if (activeTab !== '/ams') {
                  window.open(
                    'https://www.teambuildr.com/sport-science',
                    '_blank',
                  );
                } else {
                  batch(() => {
                    dispatch(setSelectedPackage(corePackage));
                    dispatch(setIsLearnMoreModalShowing(true));
                  });
                }
              }}
              onMouseEnter={
                !isSideBarExpanded
                  ? handleMenuTabMouseEnter({
                    title: 'Learn More',
                    legacyTitle: '',
                    description: '',
                  })
                  : null
              }
              onMouseLeave={!isSideBarExpanded ? handleMenuTabMouseLeave : null}
            >
              <UpgradeButtonIconContainer isSideBarExpanded={isSideBarExpanded}>
                <IcomoonReact
                  iconSet={iconSet}
                  size={isSideBarExpanded ? 16 : 24}
                  icon='question-mark'
                  color={isSideBarExpanded ? '#ffffff' : '#444444'}
                />
              </UpgradeButtonIconContainer>
              <div className='button-text'>LEARN MORE</div>
            </UpgradeButton>
          ) : (
            <UpgradeButton
              isExpanded={isSideBarExpanded}
              isActive={!isCorePackageSubscribed}
              onClick={() => {
                if (currentUser?.userSettings?.billing === 0) {
                  // billing access is disabled
                  window.open(
                    `${process.env.PHP_APP_URL
                      || 'https://app.teambuildr.com'}/billing`,
                  );
                } else if (!subscriptionStatus?.isSubscribed) {
                  handleAmplitudeUpgrade();
                  dispatch(setIsUpgradeModalShowing(true));
                  dispatch(setSelectedPackage(corePackage));
                  dispatch(
                    fetchSubscriptionPackage(currentUser.accountCode, 1),
                  );
                } else {
                  dispatch(push('/ams'));
                  setIsSideBarActive(false);
                }
              }}
              onMouseEnter={
                !isSideBarExpanded
                  ? handleMenuTabMouseEnter({
                    title: 'Upgrade',
                    legacyTitle: '',
                    description: '',
                  })
                  : null
              }
              onMouseLeave={!isSideBarExpanded ? handleMenuTabMouseLeave : null}
            >
              <UpgradeButtonIconContainer isSideBarExpanded={isSideBarExpanded}>
                <IcomoonReact
                  iconSet={iconSet}
                  size={isSideBarExpanded ? 16 : 24}
                  icon='star'
                  color={isSideBarExpanded ? '#ffffff' : '#444444'}
                />
              </UpgradeButtonIconContainer>
              <div className='button-text'>UPGRADE</div>
            </UpgradeButton>
          )}
        </ModalButtons>
      </SpacingWrapper>
      <MenuTabTooltip
        text={tooltipData.text}
        x={tooltipData.x}
        y={tooltipData.y}
        isSideBarExpanded={isSideBarExpanded}
      />
    </SideBarDiv>
  );
};

SideBar.propTypes = {
  isSideBarActive: PropTypes.bool.isRequired,
  setIsSideBarActive: PropTypes.func.isRequired,
  containerWidth: PropTypes.number.isRequired,
};

export default withLDConsumer()(SideBar);
